import HomePage from "../pages/global/HomePage";
import UsersPage from "../pages/users/UsersPage";
import DocumentTestPage from "../pages/global/DocumentTestPage";
import VacuumBreakerSelectionPage from "../pages/noza/VacuumBreakerSelectionPage";
import DeaeratorsPage from "../pages/dearators/DeaeratorsPage";
import DeaeratorsPhcPage from "../pages/dearators_phc/DeaeratorsPhcPage";
import BudgetsPage from "../pages/budgets/BudgetsPage";
import BudgetsExcelPage from "../pages/budgets_excel/BudgetsExcelPage";
import MPMetalSheetTablePage from "../pages/tables/MPMetalTablePage";
import MPStainlessSteelSheetTablePage from "../pages/tables/MPStainlessSteelTempTablePage";
import MPStainlessSteelTablePage from "../pages/tables/MPStainlessSteelTablePage";
import MPSteelElevatedTempTablePage from "../pages/tables/MPSteelElevatedTempTablePage";
import MPTubeElevatedTempTablePage from "../pages/tables/MPTubeElevatedTempTablePage";
import MPTubeRoomTempTablePage from "../pages/tables/MPTubeRoomTempTablePage";
import MPTensileStrengthVsTempPage from "../pages/tables/MPTensileStrengthVsTempPage";
import WeldingPage from "../pages/tables/WeldingPage";
import PricePerKgPage from "../pages/tables/PricePerKgPage";
import GestraPriceTablePage from "../pages/tables/GestraPriceTablePage";
import PaintSchemeTablePage from "../pages/tables/PaintSchemeTablePage";
import SpiraxSarcoPriceTablePage from "../pages/tables/SpiraxSarcoPriceTablePage";

export const protectedPageRoutes = [
  { path: "/homepage", element: <HomePage /> },
  { path: "/create-new-budget", element: <BudgetsPage /> },
  { path: "/users", element: <UsersPage /> },
  { path: "/deaerators", element: <DeaeratorsPage /> },
  { path: "/deaerators-phc", element: <DeaeratorsPhcPage /> },
  { path: "/budgets", element: <BudgetsExcelPage /> },
  { path: "/mp-metal-sheet-table", element: <MPMetalSheetTablePage /> },
  { path: "/mp-stain-steel-temp-table", element: <MPStainlessSteelSheetTablePage /> },
  { path: "/mp-stain-steel-table", element: <MPStainlessSteelTablePage /> },
  { path: "/mp-steel-elevated-temp-table", element: <MPSteelElevatedTempTablePage /> },
  { path: "/mp-tube-elevated-temp-table", element: <MPTubeElevatedTempTablePage /> },
  { path: "/mp-tube-room-temp-table", element: <MPTubeRoomTempTablePage /> },
  { path: "/mp-tensile-strength-temp-table", element: <MPTensileStrengthVsTempPage /> },
  { path: "/welding", element: <WeldingPage /> },
  { path: "/price-per-kg", element: <PricePerKgPage /> },
  { path: "/gestra-price-table", element: <GestraPriceTablePage /> },
  { path: "/paint-scheme-table", element: <PaintSchemeTablePage /> },
  { path: "/spirax-sarco-price-table", element: <SpiraxSarcoPriceTablePage /> },
  { path: "/document-test", element: <DocumentTestPage /> },
  { path: "/vacuum-breaker-select", element: <VacuumBreakerSelectionPage /> },
];
